import { useWorkspaceStore } from '@/stores/workspaceStore'
import { useProjectsStore } from '@/stores/projectsStore'
import { useProjectMembersStore } from '@/stores/projectMembersStore'
import { useDraftStore } from '@/stores/draftStore'
import { useCommitsStore } from '@/stores/commitsStore'
import { useDiagramStore } from '@/stores/diagramStore'
import { useTabsStore } from '@/stores/tabsStore'
import { useHistoryStore } from '@/stores/historyStore'
import { useClipboardStore } from '@/stores/clipboardStore'
import { useSelectionStore } from '@/stores/selectionStore'
import { useViewportStore } from '@/stores/viewportStore'
import { useTabViewStore } from '@/stores/tabViewStore'
import { clearAllDraftBackups } from '@/services/offlineCache'

export async function resetSessionState() {
  useWorkspaceStore.getState().reset()
  useProjectsStore.getState().reset()
  useProjectMembersStore.getState().reset()
  useDraftStore.getState().clearDraft()
  useDraftStore.setState({
    currentProjectId: null,
    currentProjectName: null,
    autosaveEnabled: true,
  })
  useCommitsStore.getState().reset()
  useDiagramStore.setState({
    tables: [],
    rels: [],
    groups: {},
    projectName: 'MorphERD',
    dialect: 'postgresql',
  })
  useTabsStore.setState({ activeTabId: null, tabs: [], isSwitching: false })
  useHistoryStore.getState().clearHistory()
  useClipboardStore.setState({ copiedTables: [], copiedRels: [] })
  useSelectionStore.getState().clearSelection()
  useSelectionStore.setState({
    relMode: false,
    relationshipSourceTableId: null,
    relSrcId: null,
  })
  useViewportStore.getState().reset()
  useTabViewStore.setState({ hiddenTableIds: [] })

  if ('persist' in useDiagramStore) {
    useDiagramStore.persist.clearStorage()
  }
  if ('persist' in useTabsStore) {
    useTabsStore.persist.clearStorage()
  }

  await clearAllDraftBackups()
}
